import { Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';

type StatusIconProps = {
  status: 'significant' | 'insignificant' | 'no-data';
};

export const SignificanceIcon = (props: StatusIconProps) => {
  if (props.status === 'significant') return null;

  const tooltipText =
    props.status === 'insignificant'
      ? 'Insufficient data scale to generate results'
      : 'No impression data exists for the combination';

  return (
    <Tooltip title={tooltipText} placement="top" arrow>
      <FontAwesomeIcon icon={faCircleExclamation} size="lg" />
    </Tooltip>
  );
};
